import React from "react";
import { useViewerAdvertisements } from "frontend/src/domain/audio-advertisements";
import { playUserFilesAttempted } from "frontend/src/features/play-user-files";
import { resume } from "frontend/src/features/control-audio";
import { userTracksAvailableFileTypes } from "frontend/src/domain/user-audio-file";
import { useCreateAudioAdvertisement } from "frontend/src/domain/audio-advertisements/actions";
export var maxFileSizeInMegabytes = 32;
export var usePageModel = function () {
    var advertisements = useViewerAdvertisements();
    var editedAdvertisement = useAudioAdvertisementEdit();
    var createAdvertisement = useCreateAudioAdvertisement();
    var onFileFormSubmit = function (evt) {
        evt.preventDefault();
        var file = editedAdvertisement.file.value;
        if (editedAdvertisement.validate() && file) {
            createAdvertisement.run({ file: file, title: editedAdvertisement.title.value });
        }
    };
    var play = function (_a) {
        var selected = _a.selected, id = _a.id;
        if (advertisements.data) {
            if (!selected) {
                playUserFilesAttempted({
                    tracks: advertisements.data,
                    startAtTrackIndex: advertisements.data.findIndex(function (item) { return item.id === id; }),
                });
            }
            else {
                resume();
            }
        }
    };
    return { advertisements: advertisements, play: play, editedAdvertisement: editedAdvertisement, onFileFormSubmit: onFileFormSubmit };
};
var useAudioAdvertisementEdit = function () {
    var _a = React.useState(""), title = _a[0], setTitle = _a[1];
    var _b = React.useState(null), file = _b[0], setFile = _b[1];
    var _c = React.useState(false), rightsConfirmed = _c[0], setRightsConfirmed = _c[1];
    var _d = React.useState([]), errors = _d[0], setErrors = _d[1];
    var hasUploadedFile = file !== null;
    var onFileInputChange = function (evt) {
        var files = evt.target.files;
        if (files) {
            setFile(files[0]);
            setTitle(files[0].name);
        }
        else {
            setFile(null);
        }
    };
    var validate = function () {
        var _a;
        var validation = [];
        if (!file) {
            validation.push("Загрузите файл.");
        }
        if (title.length === 0) {
            validation.push("Введите название.");
        }
        if (!rightsConfirmed) {
            validation.push("Подтвердите права на использование аудиоролика.");
        }
        if (file &&
            !userTracksAvailableFileTypes.includes((_a = file.name.split(".").pop()) !== null && _a !== void 0 ? _a : "")) {
            validation.push("\u0424\u0430\u0439\u043B \u0434\u043E\u043B\u0436\u0435\u043D \u0438\u043C\u0435\u0442\u044C \u043E\u0434\u043D\u043E \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439: " + userTracksAvailableFileTypes.join(", "));
        }
        if (file && file.size / (1024 * 1024) > maxFileSizeInMegabytes) {
            validation.push("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0444\u0430\u0439\u043B\u0430 - " + maxFileSizeInMegabytes + " \u041C\u0411.");
        }
        setErrors(validation);
        return validation.length === 0;
    };
    return {
        title: { value: title, set: setTitle },
        rightsConfirmed: { value: rightsConfirmed, set: setRightsConfirmed },
        file: { value: file, set: setFile, onChange: onFileInputChange },
        errors: errors,
        validate: validate,
        hasUploadedFile: hasUploadedFile,
    };
};
